export default "__VITE_ASSET__2164b382__"